import { __decorate, __param, __metadata, __awaiter } from 'tslib';
import { ɵɵdefineInjectable, ɵɵinject, Injectable, Inject, EventEmitter, Input, ViewChild, Output, Component, NgModule, Optional, SkipSelf } from '@angular/core';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';
import { Storage } from '@ionic/storage';
import { IonSlides, IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCPartnerListService = class UiCPartnerListService {
    constructor(param) {
        this.config = param;
    }
    getConfig() {
        return this.config;
    }
};
UiCPartnerListService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UiCPartnerListService_Factory() { return new UiCPartnerListService(ɵɵinject(APP_PARAMETER)); }, token: UiCPartnerListService, providedIn: "root" });
UiCPartnerListService = __decorate([
    Injectable({
        providedIn: 'root'
    }),
    __param(0, Inject(APP_PARAMETER)),
    __metadata("design:paramtypes", [Object])
], UiCPartnerListService);

let UiCPartnerListComponent = class UiCPartnerListComponent {
    constructor(service, storage) {
        this.service = service;
        this.storage = storage;
        this.screenWidth = 0;
        this.listPartners = [];
        this.slideOpts = {
            slidesPerView: 1,
            spaceBetween: 10,
            // Responsive breakpoints
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20
                },
                // when window width is >= 480px
                480: {
                    slidesPerView: 1,
                    spaceBetween: 30
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 2,
                    spaceBetween: 40
                }
            },
            hashNavigation: {
                replaceState: true,
            },
        };
        this.pager = false;
        this.uploadChecker = [];
        this.manyPeopleQuantity = 0;
        this.onRemovePartner = new EventEmitter();
        this.onEditPartner = new EventEmitter();
        this.onAddPartner = new EventEmitter();
        this.onCallModal = new EventEmitter();
        this.isDevolution = false;
        this.environment = (!!this.service.getConfig().device) ? this.service.getConfig().device : 'WEB';
    }
    ngOnInit() {
        this.checkStepStorage();
    }
    nextCard() {
        this.slider.slideNext();
    }
    prevCard() {
        this.slider.slidePrev();
    }
    removePartner(partnerId, index) {
        return __awaiter(this, void 0, void 0, function* () {
            this.onRemovePartner.emit({ partnerId, index });
        });
    }
    editPartner(partner) {
        this.onEditPartner.emit(partner);
    }
    addPartnerEvent() {
        this.onAddPartner.emit(true);
    }
    /**
     * retorna o status da etapa de cadastro do socio
     * @param partner
     * @param status
     * @returns
     */
    checkPartnerStatus(partner, status, statusStep) {
        if (status !== 'upload') {
            return (partner[status] !== undefined && !partner[statusStep]) ? 'checkmark-circle' : 'close-circle-outline';
        }
        const partnerUpload = this.uploadChecker.filter(arr => arr.id === partner.id)[0] || null;
        if (partnerUpload === null)
            return 'close-circle-outline';
        return (partnerUpload.upload) ? 'checkmark-circle' : 'close-circle-outline';
    }
    /**
     * retorna a class usada para o icone de status
     * @param partner
     * @param status
     * @returns
     */
    checkStatusClass(partner, status, statusStep) {
        return (this.checkPartnerStatus(partner, status, statusStep) === 'checkmark-circle') ? 'text-success' : 'text-danger';
    }
    modalPersonalData(partner) {
        this.onCallModal.emit(partner);
    }
    /**
     * retorna se ainda existem pessoas para serem cadastradas como assinatura
     * @returns
     */
    getSignatureRemains() {
        const quantity = this.listPartners.filter(arr => arr.signature === true).length;
        return quantity >= this.manyPeopleQuantity;
    }
    isMobile() {
        return (this.environment === 'APP') ? true : false;
    }
    checkStepStorage() {
        this.storage.get('isRetryOnboarding')
            .then(result => {
            this.isDevolution = result;
        });
    }
};
__decorate([
    Input(),
    __metadata("design:type", Number)
], UiCPartnerListComponent.prototype, "screenWidth", void 0);
__decorate([
    ViewChild('slider', { static: false }),
    __metadata("design:type", IonSlides)
], UiCPartnerListComponent.prototype, "slider", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], UiCPartnerListComponent.prototype, "listPartners", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCPartnerListComponent.prototype, "slideOpts", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCPartnerListComponent.prototype, "pager", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], UiCPartnerListComponent.prototype, "uploadChecker", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], UiCPartnerListComponent.prototype, "manyPeopleQuantity", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCPartnerListComponent.prototype, "steps", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], UiCPartnerListComponent.prototype, "onRemovePartner", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], UiCPartnerListComponent.prototype, "onEditPartner", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], UiCPartnerListComponent.prototype, "onAddPartner", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], UiCPartnerListComponent.prototype, "onCallModal", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], UiCPartnerListComponent.prototype, "partners", void 0);
UiCPartnerListComponent = __decorate([
    Component({
        selector: 'ui-c-partner-list',
        template: "<ion-col size=\"12\" size-xl=\"12\" class=\"mx-0\">\n  <div *ngIf=\"!!listPartners\" class=\"partner-list position-relative h-auto\">\n\n    <h3 class=\"color-primary font-family-bold text-shadow\" [style.color]=\"steps?.primaryColor\"> {{\n      'ONBORDING.V2.TEXT.TITLE.PARTNER_LISTS' | wlpTranslate }} </h3>\n    <p [style.color]=\"steps?.secondaryColor\" *ngIf=\"!getSignatureRemains()\"\n      class=\"text-center color-secondary font-family-bold text-shadow mb-2 p-0\">\n      {{ 'ONBORDING.V2.TEXT.TITLE.MANY_PEOPLE_NEED_A' | wlpTranslate }} {{ manyPeopleQuantity }} {{\n      'ONBORDING.V2.TEXT.TITLE.MANY_PEOPLE_NEED_B' | wlpTranslate }}\n    </p>\n\n    <!-- botao de voltar -->\n    <ng-container *ngIf=\"listPartners.length > 2 && !isMobile()\">\n      <div (click)=\"prevCard()\" class=\"slider-control slider-control-left position-absolute\">\n        <ion-icon name=\"caret-back-outline\"></ion-icon>\n      </div>\n    </ng-container>\n\n\n    <!-- botao de ir -->\n    <ng-container *ngIf=\"listPartners.length > 2 && !isMobile()\">\n      <div (click)=\"nextCard()\" class=\"slider-control slider-control-right position-absolute\">\n        <ion-icon name=\"caret-forward-outline\"></ion-icon>\n      </div>\n    </ng-container>\n\n    <ion-slides #slider [options]=\"slideOpts\" [pager]=\"pager\" class=\"partner-responsive\">\n      <ng-container *ngFor=\"let partner of listPartners; let i = index\">\n        <ion-slide>\n            <ion-col class=\"details\">\n              <ion-item lines=\"none\">\n                <ion-col class=\"py-3 height-card-slide\">\n                  <ion-text>\n                    <p class=\"font-weight-bold my-0 py-0 partner-name\">{{partner.fullname}}</p>\n                    <p class=\"font-weight-bold my-0\">\n                      {{partner.docNumber}}\n                      <span class=\"text-secondary font-weight-bold\" *ngIf=\"partner.master\"> {{\n                        'ONBORDING.V2.FORM.LABEL.MASTER' | wlpTranslate}} </span>\n                    </p>\n                  </ion-text>\n\n                  <div class=\"d-flex justify-content-between partners-data-responsive\">\n                    <div class=\"col-6 px-0 box-steps\">\n                      <ul class=\"list-unstyled\">\n                        <li class=\"font-weight-bold\"> {{ 'ONBORDING.V2.FORM.LABEL.STEPS' | wlpTranslate }}: </li>\n                        <li [ngClass]=\"checkStatusClass(partner, 'personalData','isPersonalData') + ' mt-1'\">\n                          <ion-icon [name]=\"checkPartnerStatus(partner, 'personalData','isPersonalData')\"></ion-icon> {{\n                          'ONBORDING.V2.FORM.LABEL.PERSONAL_DATA' | wlpTranslate }}\n                        </li>\n                        <li [ngClass]=\"checkStatusClass(partner, 'personalAddress','isPersonalAddress') + ' mt-1'\">\n                          <ion-icon [name]=\"checkPartnerStatus(partner, 'personalAddress','isPersonalAddress')\">\n                          </ion-icon> {{\n                          'ONBORDING.V2.FORM.LABEL.ADDRESS' | wlpTranslate }}\n                        </li>\n                        <li [ngClass]=\"checkStatusClass(partner, 'upload') + ' mt-1'\">\n                          <ion-icon [name]=\"checkPartnerStatus(partner, 'upload')\"></ion-icon> {{\n                          'ONBORDING.V2.FORM.LABEL.UPLOAD' | wlpTranslate }}\n                        </li>\n                      </ul>\n\n                      <!-- <ul class=\"list-unstyled\" *ngIf=\"isDevolution\">\n                        <li class=\"font-weight-bold\"> {{ 'ONBORDING.V2.FORM.LABEL.STEPS' | wlpTranslate }}: </li>\n                        <li class='text-success'>\n                          <ion-icon [name]=\"checkPartnerStep(partner, 'PERSONAL_DATA')\"></ion-icon> {{\n                          'ONBORDING.V2.FORM.LABEL.PERSONAL_DATA' | wlpTranslate }}\n                        </li>\n\n                        <li class='text-success'>\n                          <ion-icon [name]=\"checkPartnerStatus(partner, 'PERSONAL_ADDRESS')\"></ion-icon> {{\n                          'ONBORDING.V2.FORM.LABEL.ADDRESS' | wlpTranslate }}\n                        </li>\n\n                        <li [ngClass]=\"checkStatusClass(partner, 'upload')\">\n                          <ion-icon [name]=\"checkPartnerStatus(partner, 'upload')\"></ion-icon> {{\n                          'ONBORDING.V2.FORM.LABEL.UPLOAD' | wlpTranslate }}\n                        </li>\n                      </ul> -->\n\n                    </div>\n                    <div class=\"col-6 px-0\">\n                      <ul class=\"list-unstyled\">\n                        <li class=\"font-weight-bold\"> {{ 'ONBORDING.V2.FORM.LABEL.PARTNER_TYPE' | wlpTranslate }}:\n                        </li>\n                        <li *ngIf=\"partner.legalRepresentative\"> {{\n                          'ONBORDING.V2.FORM.LABEL.LEGAL_REPRESENTATIVE' | wlpTranslate }} </li>\n                        <li *ngIf=\"partner?.partner\"> {{ 'ONBORDING.V2.FORM.LABEL.PARTNER' | wlpTranslate }}\n                        </li>\n                        <li *ngIf=\"partner?.attorney\"> {{ 'ONBORDING.V2.FORM.LABEL.ATTORNEY' | wlpTranslate }}\n                        </li>\n                        <li *ngIf=\"partner?.signature\"> {{ 'ONBORDING.V2.FORM.LABEL.SIGNATURE' | wlpTranslate\n                          }} </li>\n                      </ul>\n\n                    </div>\n\n                  </div>\n\n                  <div class=\"d-flex flex-wrap justify-content-center align-items-center\">\n\n                    <ui-c-button data-cy=\"onboarding-pj-inputinfos-btn\" (continue)=\"modalPersonalData(partner)\" class=\"btn-cta-modal\" [ngClass]=\"{'mb-2': screenWidth >= 470}\"> \n                      {{ 'ONBORDING.V2.BUTTON.INPUT_INFOS' | wlpTranslate }}\n                    </ui-c-button>\n\n                    <div class=\"col-12 px-0 d-flex justify-content-start align-items-center\">\n                      <div class=\"col-6 px-0 text-center\" *ngIf=\"!partner.isPersonalStartStep\">\n                        <ion-button (click)=\"editPartner(partner)\" fill=\"clear\" color=\"success\"\n                          class=\"text-secondary font-family-semibold mx-1\"> {{\n                          'ONBORDING.V2.BUTTON.EDIT' | wlpTranslate }} </ion-button>\n                      </div>\n\n                      <div class=\"col-6 px-0 text-center\" *ngIf=\"partner.isPersonalStartStep\">\n                        <ion-button (click)=\"editPartner(partner)\" fill=\"clear\" color=\"success\"\n                          [ngClass]=\"partner.isPersonalStartStep ? 'isDevolutionFontSize':''\"\n                          class=\"text-secondary font-family-semibold mx-1\">\n                          <ion-icon [ngClass]=\"partner.isPersonalStartStep ? 'isDevolutionIconSize':''\" slot=\"start\"\n                            name=\"alert-circle-outline\"></ion-icon>\n                          Revisar\n                        </ion-button>\n                      </div>\n\n                      <div class=\"col-6 px-0 text-center\">\n                        <ion-button [ngClass]=\"partner.isPersonalStartStep ? 'isDevolutionFontSize':''\"\n                          (click)=\"removePartner(partner.id, i)\" fill=\"clear\" color=\"danger\"\n                          class=\"text-secondary font-family-semibold px-2 mx-0\"> {{\n                          'ONBORDING.V2.BUTTON.REMOVE' | wlpTranslate }} </ion-button>\n                      </div>\n                    </div>\n\n                  </div>\n                </ion-col>\n              </ion-item>\n            </ion-col>\n        </ion-slide>\n      </ng-container>\n\n      <!-- card para add partner -->\n      <ng-container *ngIf=\"listPartners.length === 0 && isMobile()\">\n        <ion-slide (click)=\"addPartnerEvent()\">\n          <ion-row>\n            <ion-col class=\"details\">\n              <ion-item lines=\"none\">\n                <ion-col class=\"py-3\">\n\n                  <div class=\"card-icon\">\n                    <ion-icon class=\"text-primary\" name=\"people-outline\"></ion-icon>\n                    <ion-text class=\"text-primary text-center w-100 d-block\">\n                      {{ 'ONBORDING.V2.TEXT.TITLE.NO_PARTNER_ADD' | wlpTranslate: manyPeopleQuantity }}\n                    </ion-text>\n                  </div>\n                </ion-col>\n              </ion-item>\n            </ion-col>\n          </ion-row>\n        </ion-slide>\n      </ng-container>\n\n      <ng-container *ngIf=\"listPartners.length === 0\">\n        <ion-slide (click)=\"addPartnerEvent()\">\n          <ion-row>\n            <ion-col class=\"details\">\n              <ion-item lines=\"none\">\n                <ion-col class=\"py-3\">\n\n                  <div class=\"card-icon\">\n                    <ion-icon class=\"text-primary\" name=\"people-outline\"></ion-icon>\n                    <ion-text class=\"text-primary text-center w-100 d-block\">\n                      {{ 'ONBORDING.V2.TEXT.TITLE.NO_PARTNER_ADD' | wlpTranslate: manyPeopleQuantity }}\n                    </ion-text>\n                  </div>\n                </ion-col>\n              </ion-item>\n            </ion-col>\n          </ion-row>\n        </ion-slide>\n      </ng-container>\n\n    </ion-slides>\n\n  </div>\n</ion-col>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [UiCPartnerListService, Storage])
], UiCPartnerListComponent);

var UiCPartnerListModule_1;
let UiCPartnerListModule = UiCPartnerListModule_1 = class UiCPartnerListModule {
    constructor(selfModule) { }
    static forRoot(config) {
        return {
            ngModule: UiCPartnerListModule_1,
            providers: [
                { provide: APP_PARAMETER, useValue: config }
            ]
        };
    }
};
UiCPartnerListModule = UiCPartnerListModule_1 = __decorate([
    NgModule({
        declarations: [
            UiCPartnerListComponent
        ],
        imports: [
            IonicModule,
            CommonModule,
            UiCButtonModule,
            UiBsTranslateModule
        ],
        exports: [
            UiCPartnerListComponent
        ],
        providers: [
            UiCPartnerListService
        ]
    }),
    __param(0, Optional()), __param(0, SkipSelf()),
    __metadata("design:paramtypes", [UiCPartnerListModule])
], UiCPartnerListModule);

export { UiCPartnerListComponent, UiCPartnerListModule, UiCPartnerListService };
//# sourceMappingURL=wlp-ui-c-partner-list.js.map
